import { Backdrop, BackdropProps, Box, Button, CircularProgress, Typography } from '@mui/material';

export const LoadingBackdrop = (props: Omit<BackdropProps, 'open'> & { caption?: string, onCancel?: () => void; }) => {

    return <Backdrop
        {...props}
        sx={{ ...props.sx ?? {}, color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={true}
    >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <table border={0}><tbody>
                <tr><td>
                    <Typography component='div' color="white">{props.caption ?? 'Chargement ...'}<CircularProgress sx={{ ml: '5px' }} size={20} color="inherit" /></Typography>
                </td></tr>
                {props.onCancel ? <tr><td><Typography component='div' color="white" sx={{ width: '100%', textAlign: 'center' }}><Button variant='contained' size='small' onClick={props.onCancel}>Annuler</Button></Typography></td></tr> : null}
            </tbody>
            </table>
        </Box>

    </Backdrop>;
};
